import React from 'react';
import '../../styles/components/AsperaLeftNav.scss';
import { withRouter } from 'react-router-dom';
import { Button, getIconComponent, Theme } from '../Carbon';
import { openNewTab, altKeysUsed, resetTableStore } from '../../helpers/starterHelpers';
import { language } from '../../services/LanguageService';
import { tracking } from '../../services/TrackingService';
import { SubManager } from '../../classes/SubManager';
import { AsperaError } from '../../classes/AsperaError';
/**
 * React Component
 *
 * The AsperaDesktopLeftNav component renders the left navigation bar for Aspera
 *
 * @example
 * ```javascript
 * <AsperaDesktopLeftNav />
 * ```
 */
export const AsperaDesktopLeftNav = withRouter(class AsperaDesktopLeftNav extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            expanded: false,
        };
        this.items = [];
        this.subManager = new SubManager();
        this.lastOpenCheckSubId = '';
        this.asperaHasChildrenClass = 'aspera-left-nav--has-active-child';
        this.handleFinalClick = (event, item) => {
            const { history, desktopLeftNavSubject } = this.props;
            event.preventDefault();
            resetTableStore();
            if (typeof item.onClick === 'function') {
                item.onClick(item, event);
            }
            if (desktopLeftNavSubject) {
                desktopLeftNavSubject.next(false);
            }
            if (item.route) {
                const newTab = altKeysUsed(event);
                newTab ? openNewTab(item.route) : history.push(item.route);
            }
            this.setState({ expanded: false });
            tracking.track('Navigate UI', { action: 'Clicked Left Nav Item', actionType: item.title, successFlag: true });
        };
        this.handleClick = (event, item) => {
            event.preventDefault();
            tracking.checkDirtyForms(() => this.handleFinalClick(event, item));
        };
    }
    checkIfActive(navItem) {
        const { history } = this.props;
        if (navItem.route && ((navItem.exact && history.location.pathname === navItem.route) || (!navItem.exact && history.location.pathname.indexOf(navItem.route || '') === 0))) {
            return true;
        }
        if (Array.isArray(navItem.exactExclude) && history.location.pathname.indexOf(navItem.route || '') === 0) {
            const foundExcludeMatch = navItem.exactExclude.filter(item => {
                return history.location.pathname.indexOf(item) > -1;
            });
            return !foundExcludeMatch.length;
        }
        return false;
    }
    getItems() {
        const { expanded } = this.state;
        return this.items.filter(item => !item.hidden).map((item, key) => {
            return React.createElement(Button, { className: `desktop-left-nav-item ${this.checkIfActive(item) ? 'active-left-nav' : ''} ${item.needsAttention ? `needs-attention-${item.needsAttention}` : ''}`, key: key, kind: "ghost", renderIcon: item.icon || getIconComponent('Settings', 20), hasIconOnly: !expanded, label: item.title, iconDescription: item.title, tooltipPosition: "right", tooltipAlignment: "start", "data-auto": `left-nav-item-${item.route || item.title}`, onClick: (event) => {
                    this.handleClick(event, item);
                } },
                React.createElement("span", null, item.title));
        });
    }
    getHeadingOpenClose() {
        const { expanded } = this.state;
        const { productName, desktopLeftNavSubject } = this.props;
        return React.createElement(Button, { className: "desktop-left-nav-item", kind: "ghost", renderIcon: expanded ? getIconComponent('Close', 20) : getIconComponent('Menu', 20), hasIconOnly: !expanded, iconDescription: language.get('header.openLeftNav'), label: language.get('header.openLeftNav'), tooltipPosition: "right", tooltipAlignment: "start", "data-auto": "left-nav-item-primary-open", onClick: () => {
                this.setState({ expanded: !expanded });
                if (desktopLeftNavSubject) {
                    desktopLeftNavSubject.next(!expanded);
                }
            } },
            React.createElement("span", null,
                language.get('globals.ibm'),
                "\u00A0",
                React.createElement("span", { className: "product-name" }, productName)));
    }
    getButton() {
        const { actionButton, desktopLeftNavSubject } = this.props;
        const { expanded } = this.state;
        if (actionButton) {
            return React.createElement("div", { className: "left-nav-action" },
                React.createElement(Button, { "data-auto": "left-nav-action-button", onClick: () => {
                        if (desktopLeftNavSubject) {
                            desktopLeftNavSubject.next(false);
                        }
                        actionButton.onClick();
                    }, kind: actionButton.type, renderIcon: actionButton.icon, hasIconOnly: !expanded, label: actionButton.title, iconDescription: actionButton.title, tooltipPosition: "right", tooltipAlignment: "start" }, actionButton.title));
        }
    }
    getDropdownMenu() {
        const { dropdownMenu } = this.props;
        if (dropdownMenu) {
            return (React.createElement("div", { className: "aspera-left-nav-dropdown" }, dropdownMenu));
        }
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    componentDidMount() {
        const { itemsSubscriber } = this.props;
        this.subManager.setSubscription(itemsSubscriber.subscribe({
            next: items => {
                this.subManager.unsubscribe(this.lastOpenCheckSubId);
                this.items = items || [];
                this.setState({});
            },
            error: error => {
                new AsperaError('AsperaDesktopLeftNav: Unable to monitor for left nav updates', error);
            },
        }));
    }
    render() {
        const { className, hideLeftNav, headerIsHidden } = this.props;
        const { expanded } = this.state;
        return (React.createElement(Theme, { theme: "g100", className: `aspera-left-nav aspera-desktop-left-nav ${className ? className : ''} ${hideLeftNav ? 'hide-left-nav' : ''}` },
            React.createElement("nav", { className: `cds--side-nav__navigation cds--side-nav left-nav-wrapper left-nav-no-header cds--side-nav--ux left-nav-wrapper ${headerIsHidden ? 'left-nav-no-header' : ''} ${expanded ? 'expanded-left-nav-menu' : ''}`, "aria-label": language.get('leftNav.sideNavigation') },
                this.getHeadingOpenClose(),
                this.getDropdownMenu(),
                React.createElement("div", { className: "aspera-desktop-left-nav--items" }, this.getItems()),
                this.getButton())));
    }
});
